import { httpClient } from '../httpClient';

// Spec 026 — Accreditation Certificate CRUD + lifecycle (FR-026-02, Art 4.C)
export const dataflowCertificatesApi = {
  list: (params) =>
    httpClient.get('/dataflow/certificates/', { params }),

  getById: (id) =>
    httpClient.get(`/dataflow/certificates/${id}`),

  create: (data) =>
    httpClient.post('/dataflow/certificates/', data),

  update: (id, data) =>
    httpClient.patch(`/dataflow/certificates/${id}`, data),

  delete: (id) =>
    httpClient.delete(`/dataflow/certificates/${id}`),

  uploadDocument: (id, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return httpClient.post(`/dataflow/certificates/${id}/document`, fd);
  },

  downloadDocument: (id) =>
    httpClient.get(`/dataflow/certificates/${id}/document`, { responseType: 'blob' }),

  revoke: (id, data) =>
    httpClient.post(`/dataflow/certificates/${id}/revoke`, data),

  suspend: (id) =>
    httpClient.post(`/dataflow/certificates/${id}/suspend`, {}),

  reinstate: (id) =>
    httpClient.post(`/dataflow/certificates/${id}/reinstate`, {}),
};
